module.exports = __webpack_public_path__ + "img/search.97f0fc88.svg";